import React from 'react';
import { useStyles } from './styles';
import useDotLottie from '../../pages/hooks/useDotLottie';
import LOADING_ANIMATION from '../../commons/images/icons/ecal-connector-lottie.lottie?url';

function LoadingAnimation () {
    const classes = useStyles();
    const { canvasRef } = useDotLottie({ src: LOADING_ANIMATION });

    return (
        <div className={classes.wrapper}>
            <canvas
                ref={canvasRef}
                className={classes.loadingAnimation}
                role="img"
                aria-label="loading"
            />
        </div>
    );
}

export default LoadingAnimation;
